<template>
  <Layout>
    <div class="mb-3 col-1">
      <RouterLink v-if="root === 'dashboard'" to="/">
        <h4 class="font-size-14 color pointer">
          <i class="mdi mdi-arrow-left"></i> Retour</h4>
      </RouterLink>
      <RouterLink v-else-if="root === 'proposals'" to="/proposals">
        <h4 class="font-size-14 color pointer">
          <i class="mdi mdi-arrow-left"></i> Retour </h4>
      </RouterLink>
      <a v-else-if="root === 'propFolder'"  @click="redirection">
        <h4 class="font-size-14 color pointer">
          <i class="mdi mdi-arrow-left"></i> Retour </h4>
      </a>
      <a v-else-if="root === 'undefined'" @click="redirection" class="pointer">
        <h4 class="font-size-14 color" v-if="!loadingDetails">
          <i class="mdi mdi-arrow-left"></i> Retour </h4>
      </a>
    </div>
    <div class="row mb-3">
      <div class="col-sm-6 d-flex  align-items-center">
        <a @click="redirection">
          <h4 class="font-size-14 pt-2 pointer" v-if="!loadingDetails">
            {{ proposal.request.id }} - {{ proposal.request.note }} <i class="mdi mdi-link-variant"></i></h4>
          <h4 v-else>
            <b-spinner variant="success" small></b-spinner>
          </h4>
        </a>
        <div class="col-sm-6">
          <div class="d-flex style-rating col-5">
            <b-form-rating v-model="value" size="lg" color="#EBB13F" no-border readonly></b-form-rating>
          </div>
        </div>
      </div>
    </div>
    <div class="checkout-tabs">
      <b-tabs
          pills
          vertical
          nav-class="p-0"
          nav-wrapper-class="col-xl-2 col-sm-3"
      >
        <b-tab active>
          <template v-slot:title>
            <i class="fas fa-info-circle d-block  check-nav-icon mt-3 mb-1"></i>
            <p class="fw-bold mb-3">Informations</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane fade show active">
                  <h4 class="card-title mb-2 ">Informations</h4>
                  <div class="table-responsive px-2">
                    <table class="table table-nowrap">
                      <tbody>
                      <tr>
                        <th scope="row">Proposition :</th>
                        <td v-if="!loadingDetails && proposal.poNumber">#{{ proposal.id }} -
                          {{ proposal.poNumber }}
                        </td>
                        <td v-else-if="loadingDetails">
                          <b-spinner variant="success" small></b-spinner>
                        </td>
                        <td v-else class="text-muted-color">Aucune donnée</td>
                      </tr>
                      <tr>
                        <th scope="row">Date de création :</th>
                        <td v-if="proposal.createdAt">{{ formatDate(proposal.createdAt) }}</td>
                        <td v-else-if="loadingDetails">
                          <b-spinner variant="success" small></b-spinner>
                        </td>
                        <td v-else class="text-muted-color">Aucune donnée</td>
                      </tr>
                      <tr>
                        <th scope="row">Dernière modification :</th>
                        <td v-if="proposal.updatedAt">{{ formatDate(proposal.updatedAt) }}</td>
                        <td v-else-if="loadingDetails">
                          <b-spinner variant="success" small></b-spinner>
                        </td>
                        <td v-else class="text-muted-color">Aucune donnée</td>
                      </tr>
                      <tr class="mb-5 style-text">
                        <th scope="row">Détails :</th>
                        <td v-if="proposal.s_quote_detail">{{ proposal.s_quote_detail }}</td>
                        <td v-else-if="loadingDetails">
                          <b-spinner variant="success" small></b-spinner>
                        </td>
                        <td v-else class="text-muted-color">Aucune donnée</td>
                      </tr>
                      <tr>
                        <th scope="row">Fichier1:</th>
                        <td :class="(proposal.s_quote_att_1)?'file':'disable-item'">
                          <a href="#" @click="downloadFile(proposal.s_quote_att_1)">Télécharger</a>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Fichier2:</th>
                        <td :class="(proposal.s_quote_att_2)?'file':'disable-item'">
                          <a href="#" @click="downloadFile(proposal.s_quote_att_2)">Télécharger</a>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Fichier3:</th>
                        <td :class="(proposal.s_quote_att_3)?'file':'disable-item'">
                          <a href="#" @click="downloadFile(proposal.s_quote_att_3)">Télécharger</a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->
          </b-card-text>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-user d-block check-nav-icon mt-3 mb-1"></i>
            <p class="fw-bold mb-3">Demandeur</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane">
                  <h4 class="card-title mb-5">Demandeur</h4>
                  <div class="table-responsive px-2">
                    <table class="table table-nowrap">
                      <tbody>
                      <tr v-if="!proposal.request.quote_details">
                        <th scope="row">Nom :</th>
                        <td v-if=" proposal.owner.username">{{ proposal.owner.username }}</td>
                        <td v-else-if="loadingDetails">
                          <b-spinner variant="success" small></b-spinner>
                        </td>
                        <td v-else class="text-muted-color">Aucune donnée</td>
                      </tr>
                      <tr v-if="!proposal.request.quote_details">
                        <th scope="row">Adresse e-mail :</th>
                        <td v-if="proposal.owner.email">{{ proposal.owner.email }}</td>
                        <td v-else-if="loadingDetails">
                          <b-spinner variant="success" small></b-spinner>
                        </td>
                        <td v-else class="text-muted-color">Aucune donnée</td>
                      </tr>
                      <tr>
                        <th scope="row">Lieux du dossier :</th>
                        <td v-if="proposal.request.customerUser.city">
                          {{(proposal.request.customerUser.country.toUpperCase() === "FR") ? 'France' : proposal.request.customerUser.country }}
                          - {{ proposal.request.customerUser.city }}
                        </td>
                        <td v-else-if="loadingDetails">
                          <b-spinner variant="success" small></b-spinner>
                        </td>
                        <td v-else class="text-muted-color">Aucune donnée</td>
                      </tr>
                      <tr>
                        <th scope="row">Situation professionnelle :</th>
                        <td v-if=" proposal.request.s_situation_pro">
                          {{ professionalSituationStatus(proposal.request.s_situation_pro) }}
                        </td>
                        <td v-else-if="loadingDetails">
                          <b-spinner variant="success" small></b-spinner>
                        </td>
                        <td v-else class="text-muted-color">Aucune donnée</td>
                      </tr>
                      <tr>
                        <th scope="row">Revenus net imposables :</th>
                        <td v-if="proposal.request.s_montant_impot">
                          {{ proposal.request.s_montant_impot | truncateMontant() }}
                        </td>
                        <td v-else-if="loadingDetails">
                          <b-spinner variant="success" small></b-spinner>
                        </td>
                        <td v-else class="text-muted-color">Aucune donnée</td>
                      </tr>
                      <tr>
                        <th scope="row">Mensualité des crédits :</th>
                        <td v-if="proposal.request.s_montant_credit">
                          {{ proposal.request.s_montant_credit | truncateMontant() }}
                        </td>
                        <td v-else-if="loadingDetails">
                          <b-spinner variant="success" small></b-spinner>
                        </td>
                        <td v-else class="text-muted-color">Aucune donnée</td>
                      </tr>
                      <tr>
                        <th scope="row">Montant de l’apport :</th>
                        <td v-if="proposal.request.s_montant_impot">
                          {{ proposal.request.s_montant_impot | truncateMontant() }}
                        </td>
                        <td v-else-if="loadingDetails">
                          <b-spinner variant="success" small></b-spinner>
                        </td>
                        <td v-else class="text-muted-color">Aucune donnée</td>
                      </tr>
                      <tr>
                        <th scope="row">Durée du crédit souhaitée :</th>
                        <td v-if="proposal.request.s_duree_credit_souhait">
                          {{ creditsStatus(proposal.request.s_duree_credit_souhait) }}
                        </td>
                        <td v-else-if="loadingDetails">
                          <b-spinner variant="success" small></b-spinner>
                        </td>
                        <td v-else class="text-muted-color">Aucune donnée</td>
                      </tr>
                      <tr>
                        <th scope="row">Mensualité maximum :</th>
                        <td v-if="proposal.request.s_montant_mens_max ">
                          {{ proposal.request.s_montant_mens_max | truncateMontant() }}
                        </td>
                        <td v-else-if="loadingDetails">
                          <b-spinner variant="success" small></b-spinner>
                        </td>
                        <td v-else class="text-muted-color">Aucune donnée</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

/**
 * FAQs component
 */
export default {
  page: {
    title: "Details",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout},
  data() {
    return {
      title: "Détails",
      items: [],
      toEditProfile: false,
      favoris: false,
      root: "",
      value: 0,
    };
  },
  mounted() {
    this.getDetails();
    localStorage.setItem('root', this.$route.query.name);
    this.root = localStorage.getItem('root');
  },
  methods: {
    getDetails() {
      this.$store.dispatch("proposals/proposalDetails", this.$route.params.id);
    },
    pathImage(name) {
      return this.baseURL + "/uploads/images/" + name;
    },
    formatDate(object) {
      let d = new Date(object);
      let ye = new Intl.DateTimeFormat("fr", {year: "numeric"}).format(d);
      let mo = new Intl.DateTimeFormat("fr", {month: "short"}).format(d);
      let da = new Intl.DateTimeFormat("fr", {day: "2-digit"}).format(d);
      return `${da} ${mo} ${ye}`;
    },
    downloadFile(value) {
      var a = document.createElement("a"); //Create <a>
      a.href = `data:${value.mimeType};base64,` + value.content; //Image Base64 Goes here
      a.download = `${value.originalFilename}`; //File name Here
      a.click(); //Downloaded file
    },
    changeNote(value) {
      return (value.hasOwnProperty('s_rating')) ? this.value = Number(value.s_rating) : this.value;
    },
    redirection() {
      this.$root.$router.push({
        path: '/folders/' + this.proposal.request.id,
        query: {name: this.$route.params.id}
      })
    },
  },
  computed: {
    proposal() {
      let value = this.$store.getters["proposals/getDetails"];
      if (isset(() => value.request)) {
        this.changeNote(value.request);
      }
      return value;
    },
    loadingDetails() {
      return this.$store.getters["proposals/getIsLoadingDetails"];
    },
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
    truncateMontant: function (text) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(text)
    },
  },
};

function isset(accessor) {
  try {
    // Note we're seeing if the returned value of our function is not
    // undefined or null
    return accessor() !== undefined && accessor() !== null
  } catch (e) {
    // And we're able to catch the Error it would normally throw for
    // referencing a property of undefined
    return false
  }
}
</script>
<style scoped lang="scss">
th {
  width: 15px !important;
  line-height: 30px !important;
}

td {
  line-height: 30px !important;
}

h4 {
  color: #000000 !important;
  margin-left: 20px;
}

h2 {
  color: #000000 !important;
  font-weight: normal;
  font-family: Inter, sans-serif !important;
}

.file a {
  color: #2E7AD4 !important;
}

.file a:hover {
  color: #A23662 !important;
}

.color {
  color: #747C8D;
}

.disable-item a {
  cursor: not-allowed;
  color: gray;
  opacity: 0.6;
  display: inline-block;
  pointer-events: none;
  text-decoration: none;
}

.style-text .table-nowrap th, .table-nowrap td {
  white-space: unset !important;
  text-align: justify;
}

::v-deep span.b-rating-star.b-rating-star-empty svg {
  fill: #74788d;
}

.style-rating .form-control {
  display: flex !important;
  width: 100%;
  line-height: 1.5;
  background-color: unset;
  background-clip: unset;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 1px solid #EFF2F7;
  border-radius: 4px;
  vertical-align: baseline;
}

a.router-link-active h4.color {
  color: #747C8D !important;
  margin-left: -3px;
}

a h4:hover {
  color: #1F84D2 !important;
  margin-left: -3px;
}

a h4 {
  margin-left: -3px;
}

a.router-link-active h4:hover {
  color: #1F84D2 !important;
  margin-left: -3px;
}
</style>
